import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ClientDashboardChart, VerticalGraph, LeadsBarChart, LeadsPieChart } from '../../../components'

import instagram from "../../../assests/instagram_1.svg"
import facebook from "../../../assests/facebook.png"
import twitter from "../../../assests/twitter.svg"
import linkedin from "../../../assests/linkedin_1.svg"
import reports from "../../../assests/reports_active.png"
import { SocialMediaMetricsCard,LeadsCard } from '../../../components'
import { getDashboardPaidSocialMetrics } from '../../../services/ApiService'
import LoadingSpinner from '../../../components/client/LoadingSpinner'
import { getPlatformNameOrId } from '../../../helpers/getPlatformName'
import NewPaidSocialDashboard from './new_paid_social_dashboard/NewPaidSocialDashboard'
import { useSelector } from 'react-redux'

const PaidSocial = () => {

    const [socialMediaProcessedData,setSocialMediaProcessedData] =useState({})
    const [paidSocialAccountStatus,setPaidSocialAccountStatus]=useState([])
    const [topPerformingCampaigns,setTopPerformingCampaigns]=useState([])
    const [topPerformingPlatforms,setTopPerformingPlatforms]=useState({})
    const [postReactions,setPostReactions]=useState([])
    const [loading,setLoading]=useState(false)
    const user=useSelector((state)=>state?.user)
    const filter=useSelector((state)=>state?.filter?.filter_date_range)
    

   const fetchSocialMediaCampaignMetrics = async()=>{
    try {
        setLoading(true)
     let formData = new FormData();
      formData.append('client_id', user?.client_id)
      if (filter?.days?.value == 'Custom Range') {
        formData.append('start_date', filter?.startDate)
        formData.append('end_date', filter?.endDate)
      } else if (filter?.value) {
        formData.append('days', filter?.value)
      }
   

        const data=await getDashboardPaidSocialMetrics(formData)
        
        if(data?.success){
            
            if(data?.connected_accounts)
            {
              
                setPaidSocialAccountStatus(data?.connected_accounts)
            }
            if(data?.top_performing_campaigns?.length>0)
            {
                setTopPerformingCampaigns(data?.top_performing_campaigns)
            }

            setTopPerformingPlatforms(data?.most_productive_platform)
            setPostReactions(data?.post_reactions)
           
            let finalData=await processSocialMediaData(data)
            setSocialMediaProcessedData(finalData)
        }
    } catch (error) {
        console.log(error)
    }finally{
        setLoading(false)
    }
   }

    useEffect(() => {
      fetchSocialMediaCampaignMetrics()
    }, [filter]);


    // Process the data into the desired format
    const  processSocialMediaData = (socialMediaData)=> {

         //linkedin graph data
         let linkedin_graph_data={
            labels:[],
            impressions:[],
            clicks:[],
            spent:[]
         }
         socialMediaData?.linkedin?.graph_data?.length>0 && socialMediaData?.linkedin?.graph_data.map((data)=>{
            linkedin_graph_data?.labels.push(data?.month)
            linkedin_graph_data?.impressions.push(data?.impressions)
            linkedin_graph_data?.clicks.push(data?.clicks)
            linkedin_graph_data?.spent.push(data?.spent)

         })

        //linkedin graph data
        let facebook_graph_data={
                    labels:[],
                    impressions:[],
                    clicks:[],
                    spent:[]
                 }
                 socialMediaData?.facebook?.graph_data?.length>0 && socialMediaData?.facebook?.graph_data.map((data)=>{
                    facebook_graph_data?.labels.push(data?.month)
                    facebook_graph_data?.impressions.push(data?.impressions)
                    facebook_graph_data?.clicks.push(data?.clicks)
                    facebook_graph_data?.spent.push(data?.spent)
        
                 })
                 //linkedin graph data
        let instagram_graph_data={
            labels:[],
            impressions:[],
            clicks:[],
            spent:[]
         }
         socialMediaData?.instagram?.graph_data?.length>0 && socialMediaData?.instagram?.graph_data.map((data)=>{
            instagram_graph_data?.labels.push(data?.month)
            instagram_graph_data?.impressions.push(data?.impressions)
            instagram_graph_data?.clicks.push(data?.clicks)
            instagram_graph_data?.spent.push(data?.spent)

         })

         let twitter_graph_data={
            labels:[],
            impressions:[],
            clicks:[],
            spent:[]
         }
         socialMediaData?.twitter?.graph_data?.length>0 && socialMediaData?.twitter?.graph_data.map((data)=>{
            twitter_graph_data?.labels.push(data?.month)
            twitter_graph_data?.impressions.push(data?.impressions)
            twitter_graph_data?.clicks.push(data?.clicks)
            twitter_graph_data?.spent.push(data?.spent)

         })

         


         let total_graph_data={
            linkedin:{
                impressions:linkedin_graph_data?.impressions?linkedin_graph_data?.impressions:[],
                clicks:linkedin_graph_data?.clicks?linkedin_graph_data?.clicks:[],
                spent:linkedin_graph_data?.spent?linkedin_graph_data?.spent:[],
                labels:linkedin_graph_data?.labels?linkedin_graph_data?.labels:[]
            },
            facebook:{
                impressions:facebook_graph_data?.impressions?facebook_graph_data?.impressions:[],
                clicks:facebook_graph_data?.clicks?facebook_graph_data?.clicks:[],
                spent:facebook_graph_data?.spent?facebook_graph_data?.spent:[],
                labels:facebook_graph_data?.labels?facebook_graph_data?.labels:[]
                
            },
            instagram:{
                impressions:instagram_graph_data?.impressions?instagram_graph_data?.impressions:[],
                clicks:instagram_graph_data?.clicks?instagram_graph_data?.clicks:[],
                spent:instagram_graph_data?.spent?instagram_graph_data?.spent:[],
                labels:instagram_graph_data?.labels?instagram_graph_data?.labels:[]
                
            },
            twitter:{
                impressions:twitter_graph_data?.impressions?twitter_graph_data?.impressions:[],
                clicks:twitter_graph_data?.clicks?twitter_graph_data?.clicks:[],
                spent:twitter_graph_data?.spent?twitter_graph_data?.spent:[],
                labels:twitter_graph_data?.labels?twitter_graph_data?.labels:[]
                
            }

         }

        return {
                matrics: [
                
                    {
                        name: "Facebook",
                        clicks: socialMediaData.facebook.clicks,
                        impressions: socialMediaData.facebook.impressions,
                        spend:"$"+socialMediaData.facebook.spend,
                        icon: facebook,  // Replace with actual icon variable if available
                        border_color: '#D3A4FF',
                        graph_data:facebook_graph_data,
                        selectedPlatform:{
                            value:getPlatformNameOrId('Facebook'),
                            label:'Facebook Ads'
                        }
                    },
                    {
                        name: "Instagram",
                        clicks: socialMediaData.instagram.clicks,
                        impressions: socialMediaData.instagram.impressions,
                        spend: "$"+socialMediaData.instagram.spend,
                        icon: instagram,  // Replace with actual icon variable if available
                        border_color: '#FFB1E0',
                        graph_data:instagram_graph_data,
                        selectedPlatform:{
                            value:getPlatformNameOrId('Instagram'),
                            label:'Instagram Ads'
                        }
                    },
                    {
                        name: "LinkedIn",
                        clicks: socialMediaData.linkedin.clicks,
                        impressions: socialMediaData.linkedin.impressions,
                        spend: "$"+socialMediaData.linkedin.spend,
                        icon: linkedin,  // Replace with actual icon variable if available
                        border_color: '#FFE58A',
                        graph_data:linkedin_graph_data,
                        selectedPlatform:{
                            value:getPlatformNameOrId('LinkedIn'),
                            label:'LinkedIn Ads'
                        }
                    },
                    // {
                    //     name: "Twitter",
                    //     clicks: socialMediaData.twitter.clicks,
                    //     impressions: socialMediaData.twitter.impressions,
                    //     spend: socialMediaData.twitter.spend,
                    //     icon: twitter,  // Replace with actual icon variable if available
                    //     border_color: '#95F3FA',
                    //     graph_data:twitter_graph_data,
                    //     selectedPlatform:{
                    //         value:getPlatformNameOrId('Twitter'),
                    //         label:'Twitter Ads'
                    //     }
                    // }
                    {
                        name: "OverView",
                        clicks: socialMediaData.total.total_clicks,
                        impressions: socialMediaData.total.total_impressions,
                        spend: "$"+socialMediaData.total.total_spend,
                        icon: reports,  // Replace with actual icon variable if available
                        border_color: '#95F3FA',
                        graph_data:twitter_graph_data,
                        selectedPlatform:{
                            value:getPlatformNameOrId('Twitter'),
                            label:'Twitter Ads'
                        }
                    }
                ], 
                barchart_graph_data:[
                    {
                        label: 'Facebook',
                        backgroundColor: '#D3A4FF', 
                        borderColor: '#D3A4FF',
                        borderWidth: 1,
                        data: [socialMediaData.facebook.clicks, socialMediaData.facebook.impressions,  socialMediaData.facebook.spend] // Leads data
                    },
                    {
                        label: 'Instagram',
                        backgroundColor: '#FFB1E0', // Green bars
                        borderColor: '#FFB1E0',
                        borderWidth: 1,
                        data: [socialMediaData.instagram.clicks, socialMediaData.instagram.impressions,  socialMediaData.instagram.spend] // Spent data
                    },
                     {
                        label: 'LinkedIn',
                        backgroundColor: '#FFE58A', // Red bars
                        borderColor: '#FFE58A',
                        borderWidth: 1,
                        data: [socialMediaData.linkedin.clicks, socialMediaData.linkedin.impressions,  socialMediaData.linkedin.spend]
                    }
                ],



                total: {
                    clicks: socialMediaData.total.total_clicks,
                    impressions: socialMediaData.total.total_impressions,
                    spend: "$"+socialMediaData.total.total_spend,
                    border_color: '#95F3FA',
                    graph_data:total_graph_data
                  
                }
           }
    }

    
    return (
       loading?<LoadingSpinner/>:<>
       {!user?.status && <div className="d-flex justify-content-center align-items-center" >
        <div className="d-flex flex-column gap-2">
          <h5>Your account is Not Active</h5>
          <p>Please contact your administrator</p>
        </div>
      </div>}
      {!loading && user?.status && <div className='d-flex flex-column gap_lg p-0'>
           {/* <div className="row social_media_card_wrapper ">
               <div className="col-md-8">
                   <div className='row '>

                       {socialMediaData?.map((social_media) => {
                           return <div className="col-md-6 social_media_metric_card px-4 py-2 card_border">
                               <div>
                              
                                   <div className='py-4  d-flex align-items-center gap-2 heading'>
                                       <img src={social_media?.icon} alt="" />
                                       <h5 className='mb-0'>{social_media?.name}</h5><span> <Link>View Details</Link></span>
                                   </div>
                                 
                                   <div className="row">
                                       <div className="col-md-4">
                                           <p className='mb-0'>${social_media?.spent}</p>
                                           <span>Spend</span>
                                       </div>
                                       <div className="col-md-4">
                                           <p className='mb-0'>{social_media?.leads}</p>
                                           <span>Leads</span>
                                       </div>
                                       <div className="col-md-4">
                                           <p className='mb-0'>${social_media?.cpl}</p>
                                           <span>CPL</span>
                                       </div>
                                   </div>
                                
                                   <div className='py-2'>
                                       <ClientDashboardChart border_color={social_media?.border_color} />
                                   </div>
                               </div>
                           </div>

                       })}




                   </div>

               </div>
               <div className="col-md-4 social_media_metric_vertical_card p-3">
                   <div>
                       <h5 className='mb-0 pb-3 pt-1'>Total</h5>
                       <div className="row pb-md-5 pt-md-3">
                           <div className="col-md-4">
                               <p className='mb-0 spent'>$16,690</p>
                               <span>Spent</span>
                           </div>
                           <div className="col-md-4">
                               <p className='mb-0'>142</p>
                               <span>Leads</span>
                           </div>
                           <div className="col-md-4">
                               <p className='mb-0'>$85.90</p>
                               <span>CPL</span>
                           </div>
                       </div>
                       <div className='py-3'>
                           <VerticalGraph />
                       </div>


                   </div>


               </div>
           </div> */}

           {/* <div className="row chart_wrapper">
               <div className="col-md-6 ">
                   <div className="bar_chart_card px-4 py-1">
                       <div className='py-2 heading'>
                           <h5>Monthly leads conversion</h5>
                       </div>
                       <div className='py-3'>
                           <LeadsBarChart />
                       </div>


                   </div>

               </div>
               <div className="col-md-6">
                   <div className="pie_chart_card px-4 py-1">
                       <div className='py-2 heading'>
                           <h5>Application Conversion Rate Per source</h5>
                       </div>
                       <div className="row px-0">
                           <div className="col-md-5 py-3">
                               <LeadsPieChart />
                           </div>
                           <div className="col-md-7 ">
                               <div className="container">
                                   <table class="table appliaction_convertion_rate_table">
                                       <thead>
                                           <tr>
                                               <th scope="col">Social Network</th>
                                               <th scope="col">Leads</th>
                                               <th scope="col">Applications</th>
                                               <th scope="col">%</th>
                                           </tr>
                                       </thead>
                                       <tbody>
                                           <tr>
                                               <th scope="row"> 
                                                   <div className='d-flex align-items-center gap-1'>
                                                       <div className='dot facebook'></div>
                                                       <span> Facebook</span>
                                                   </div>
                                                  
                                               </th>
                                               <td>23</td>
                                               <td>14</td>
                                               <td>16.7%</td>
                                           </tr>
                                           <tr>
                                               <th scope="row">
                                               <div className='d-flex align-items-center gap-1'>
                                                   <div className='dot instagram'></div>
                                                   <span> Instagram</span>
                                               </div>
                                               </th>
                                               <td>14</td>
                                               <td>10</td>
                                               <td>20.2%</td>
                                           </tr>
                                           <tr>
                                               <th scope="row">
                                               <div className='d-flex align-items-center gap-1'>
                                                   <div className='dot twitter'></div>
                                                   <span> Twitter</span>
                                               </div>
                                               </th>
                                               <td>10</td>
                                               <td>5</td>
                                               <td>15.5%</td>
                                           </tr>
                                           <tr>
                                               <th scope="row">
                                               <div className='d-flex align-items-center gap-1'>
                                                   <div className='dot linkedin'></div>
                                                   <span> LinkedIn</span>
                                               </div>
                                               </th>
                                               <td>120</td>
                                               <td>10</td>
                                               <td>10%</td>
                                           </tr>
                                       </tbody>
                                   </table>
                               </div>

                           </div>
                       </div>

                   </div>

               </div>
           </div> */}
            
         <SocialMediaMetricsCard socialMediaData={socialMediaProcessedData} keys={['Spend','Impressions','Clicks']} />
         <LeadsCard bar_graph={true} 
         bar_graph_data={socialMediaProcessedData?.barchart_graph_data} 
         pie_chart={true} 
         labels={['Clicks','Impressions','Spend']} 
         heading="Clicks / Impressions /  Spend"
         postReactions={postReactions}
         
         />
         <NewPaidSocialDashboard 
         paidSocialAccountStatus={paidSocialAccountStatus}
         topPerformingCampaigns={topPerformingCampaigns}
         topPerformingPlatforms={topPerformingPlatforms}
         postReactions={postReactions}
         
         />
       </div>}
      </>
    )
}

export default PaidSocial